var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34103 5.41699H7.41246C6.90097 5.41699 6.41043 5.6277 6.04876 6.00278C5.68708 6.37785 5.48389 6.88656 5.48389 7.41699V19.417C5.48389 19.9474 5.68708 20.4561 6.04876 20.8312C6.41043 21.2063 6.90097 21.417 7.41246 21.417H17.0553C17.5668 21.417 18.0574 21.2063 18.419 20.8312C18.7807 20.4561 18.9839 19.9474 18.9839 19.417V7.41699C18.9839 6.88656 18.7807 6.37785 18.419 6.00278C18.0574 5.6277 17.5668 5.41699 17.0553 5.41699H15.1268M9.34103 5.41699C9.34103 6.52156 10.2045 7.41699 11.2696 7.41699H13.1982C14.2633 7.41699 15.1268 6.52156 15.1268 5.41699M9.34103 5.41699C9.34103 4.31242 10.2045 3.41699 11.2696 3.41699H13.1982C14.2633 3.41699 15.1268 4.31242 15.1268 5.41699M9.34103 12.417H9.35068M12.2339 12.417H15.1268M9.34103 16.417H9.35068M12.2339 16.417H15.1268",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.dfd8534b.svg";
export { ForwardRef as ReactComponent };